import * as types from "./types";

const mutations = {
    [types.LOADING_METRICS](state, value) {
        state.loading = value;
    },
    [types.GET_METRICS_LIST](state, metrics) {
        state.metrics = metrics;
    },
    [types.REMOVE_METRICS](state, id) {        
        state.metrics = state.metrics.filter((x) => x.id !== id);        
    },
    [types.ADD_METRICS](state, metric) {        
        state.metrics.unshift(metric);
    },
    [types.UPDATE_METRICS](state, metric) {        
        const metricsIndex = state.metrics.findIndex((x) => x.id === metric.id);
        state.metrics[metricsIndex] = metric;        
    },
    [types.GET_METRICSBYID](state, id) {
        state.id = id;
    }
};

export default mutations;